import React from 'react';

const NotFound = () => (
    <div className="error-message">
        <h1 className="error-info">404 Not Found</h1>
        <h3 className="error-more">The resource what you are looking for was not found.</h3>
    </div>
);

export default NotFound;